import React from 'react';
import './ViewSwitch.css';

interface ViewSwitchOption<T extends string> {
  value: T;
  label: string;
}

interface ViewSwitchProps<T extends string> {
  value: T;
  options: ViewSwitchOption<T>[];
  onChange: (value: T) => void;
  ariaLabel?: string;
}

/**
 * Bascule "pilule" (segmented control) reutilisable : fond gris, bouton actif blanc + orange.
 * Extrait du selecteur de perimetre (onglet Presentation acheteur) pour etre partage.
 * Generique sur la valeur : <ViewSwitch value={vue} options={[{value:'carte',label:'Carte'}, ...]} onChange={setVue} />
 */
function ViewSwitch<T extends string>({ value, options, onChange, ariaLabel }: ViewSwitchProps<T>) {
  return (
    <div className="view-switch" role="tablist" aria-label={ariaLabel}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={value === opt.value}
          className={`view-switch-btn${value === opt.value ? ' is-active' : ''}`}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default ViewSwitch;
